(() => {
  let constants = {
      videoElement: "slider-element",
      overlay: "reviews-overlay",
      close: "reviews-modal-close",
      prev: "reviews-nav-before",
      next: "reviews-nav-after",
      index: 0,
    };
  let videoElement = document.querySelectorAll(`.${constants.videoElement}`);
  const createVideo = (src, modal, modalVideo) => {
      (modalVideo.src = src),
        (modalVideo.controls = !0),
        (modalVideo.muted = !1),
        (modalVideo.height = 600),
        (modalVideo.width = 380),
        modal.append(modalVideo);
    },
    // slideInModal = (video, modalWindow) => {
      
    // },
    // slideOutModal = (video, modalWindow) => {
    //   video.remove();
    //   modalWindow.style.display = "none";
    //   document.body.classList.remove("body-locked");
    // },
    deleteVideoElement = (video, modalWindow) => {
      video.remove();
      modalWindow.style.display = "none";
      document.body.classList.remove("body-locked");
    },
    nextVideoElement = (video, modalWindowInner, modalVideo) => {},
    prevVideoElement = (video, modalWindowInner) => {
      video.remove(),
        createVideo(videoElement[index - 1].dataset.src, modalWindowInner);
    },
    createVideoElement = (video, modalWindow, modalWindowInner) => {
      document.body.classList.add("body-locked");
      let modalVideo = document.createElement("video");
      createVideo(
        video.querySelector(".video-element").dataset.src,
        modalWindowInner,
        modalVideo
      ),
      (modalWindow.style.display = "flex");
      let iconClose = document.querySelector(`.${constants.close}`),
        modalOverlay = document.querySelector(`.${constants.overlay}`),
        iconPrev = document.querySelector(`.${constants.prev}`),
        iconNext = document.querySelector(`.${constants.next}`);
        iconClose.addEventListener("click", (e) => {
          deleteVideoElement(modalVideo, modalWindow);
          // slideOutModal(modalVideo, modalWindow);
        }),
        modalOverlay.addEventListener("click", (e) => {
          deleteVideoElement(modalVideo, modalWindow);
          // slideOutModal(modalVideo, modalWindow);
        }),
        iconPrev.addEventListener("click", () => {
          constants.index == 0
            ? (constants.index = videoElement.length - 1)
            : constants.index--;
          let videoLast = document.querySelector(".video-container video");
          videoLast && videoLast.remove(),
            createVideo(
              videoElement[constants.index].querySelector(".video-element")
                .dataset.src,
              modalWindowInner,
              modalVideo
            );
        }),
        iconNext.addEventListener("click", () => {
          constants.index == videoElement.length - 1
            ? (constants.index = 0)
            : constants.index++;
          let videoLast = document.querySelector(".video-container video");
          videoLast && videoLast.remove(),
            createVideo(
              videoElement[constants.index].querySelector(".video-element")
                .dataset.src,
              modalWindowInner,
              modalVideo
            );
        });
    };
  (() => {
    let modalWindow = document.querySelector(".elo-video-reviews-modal"),
      modalWindowInner = document.querySelector(".video-container");
      Array.from(videoElement).forEach((video, index2) => {
        video.addEventListener("click", (e) => {
          console.log(modalWindow),
            modalWindow.childNodes.items
              ? modalWindow.childNodes.items.length < 1
              : ((constants.index = index2),
                createVideoElement(video, modalWindow, modalWindowInner));
        });
      });
  })();
})();
